module.exports = __webpack_public_path__ + "img/shou.7e60f059.gif";